const translations = {
  en: {
    withdrawUsing: 'Withdraw using R4Conecta',
    bank: 'Bank',
    selectOption: 'Select an option',
    selectBank: 'Select a bank.',
    id: 'ID',
    idPlaceholder: 'ID',
    phone: 'Phone',
    phonePlaceholder: 'Phone',
    amount: 'Amount',
    amountPlaceholder: 'Amount',
    currency: 'Currency',
    payoutLimits: 'Payout limits: Minimum',
    maximum: 'Maximum',
    noLimit: 'No Limit',
    back: 'BACK',
    submit: 'SUBMIT',
    warning: 'Warning',
    amountRequired: 'Amount required',
    bankRequired: 'Bank required',
    idRequired: 'ID required',
    withdrawalStatus: 'Withdrawal Status',
    amountNotPermitted: 'amount not permitted, please check your withdrawal balance',
  },
  es: {
    withdrawUsing: 'Retiro usando R4Conecta',
    bank: 'Banco',
    selectOption: 'Seleccione una opción',
    selectBank: 'Seleccione un banco.',
    id: 'Cédula',
    idPlaceholder: 'Cédula',
    phone: 'Teléfono',
    phonePlaceholder: 'Teléfono',
    amount: 'Monto',
    amountPlaceholder: 'Monto',
    currency: 'Moneda',
    payoutLimits: 'Límite de retiro: Mínimo',
    maximum: 'Máximo',
    noLimit: 'Sin límite',
    back: 'ATRÁS',
    submit: 'ENVIAR',
    warning: 'Advertencia',
    amountRequired: 'Monto requerido',
    bankRequired: 'Banco requerido',
    idRequired: 'Cédula requerida',
    withdrawalStatus: 'Estado del Retiro',
    amountNotPermitted: 'Monto no permitido, por favor verifique su saldo disponible para retiro',
  },
  pt: {
    withdrawUsing: 'Saque usando R4Conecta',
    bank: 'Banco',
    selectOption: 'Selecione uma opção',
    selectBank: 'Selecione um banco.',
    id: 'Documento',
    idPlaceholder: 'Documento',
    phone: 'Telefone',
    phonePlaceholder: 'Telefone',
    amount: 'Valor',
    amountPlaceholder: 'Valor',
    currency: 'Moeda',
    payoutLimits: 'Limite de saque: Mínimo',
    maximum: 'Máximo',
    noLimit: 'Sem limite',
    back: 'VOLTAR',
    submit: 'ENVIAR',
    warning: 'Aviso',
    amountRequired: 'Valor obrigatório',
    bankRequired: 'Banco obrigatório',
    idRequired: 'Documento obrigatório',
    withdrawalStatus: 'Status do Saque',
    amountNotPermitted: 'Valor não permitido, por favor verifique seu saldo disponível para saque',
  },
}

export default translations
